import MX200 from "./circuits/mx200.js";

class O2Sensor extends MX200 {
  constructor(...args) {
    super(...args);
    this.id = "-";
    this.status = "uninitialized";
    this.name = "o2Sensor";
  }
  async initialize() {
    await this.open("/dev/ttyO2");
    this.id = await this.getDeviceInformation();
    this.status = "ok";
  }
  async update() {
    this.value = await this.getFilteredGasConcentration();
    
    this.internalTemperature = await this.getInternalTemperature();
    this.internalBarometricPressure = await this.getInternalBarometricPressure();

    this.onBoardTemperature = await this.getOnBoardTemperature();
    this.onBoardBarometricPressure = await this.getOnBoardBarometricPressure();
    this.onBoardRelativeHumidity = await this.getOnBoardRelativeHumidity();
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      value: this.value,
      internalTemperature: this.internalTemperature,
      internalBarometricPressure: this.internalBarometricPressure,
      onBoardTemperature: this.onBoardTemperature,
      onBoardBarometricPressure: this.onBoardBarometricPressure,
      onBoardRelativeHumidity: this.onBoardRelativeHumidity
    });
  }
}

export default O2Sensor;